import { Component } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "common-video-modal",
  templateUrl: "./video-modal.component.html",
})
export class VideoModalComponent {
  safeVideoUrl: SafeResourceUrl | null = null;

  constructor(public activeModal: NgbActiveModal, private sanitizer: DomSanitizer) {}

  set videoUrl(url: string) {
    this.safeVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
